import { createContext, PropsWithChildren, useEffect, useRef, useState } from 'react';
import { Router, useHistory } from 'react-router';
import { Box, Flex } from 'reflexbox';
import { History } from 'history';

import { Modal, Popover } from '@treams/treams-ui';

export const ModalContext = createContext({ isModal: false });

export function useModalLink(url: string, modal?: boolean) {
	const history = useHistory();

	if (modal === false) {
		return url;
	}

	const params = new URLSearchParams(history.location.search);
	params.set('modal', url);

	return history.location.pathname + '?' + params.toString();
}

export default function ModalNavigation(props: PropsWithChildren<{ url: string }>) {
	const history = useHistory();

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const listeners = useRef<Record<string, (location: any) => void>>({}).current;

	const visible = !!props.url;

	const lastURL = useRef(props.url);

	if (props.url) {
		lastURL.current = props.url;
	}

	const url = lastURL.current.startsWith('/v2') ? lastURL.current : '/v2' + lastURL.current;

	const [zoom, setZoom] = useState(false);

	useEffect(() => {
		for (const listener of Object.values(listeners)) {
			listener(new URL('https://treams.com' + url));
		}

		setZoom(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.url]);

	const fake = useRef({
		...history,
		push(location: string) {
			return history.push(
				history.createHref({
					...history.location,
					search: '?modal=' + (location as string),
				}),
			);
		},
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		listen(listener: any) {
			const id = Math.random();
			listeners[id] = listener;

			return () => {
				delete listeners[id];
			};
		},
		location: new URL('https://treams.com' + url),
	}).current as unknown as History;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(fake as any).location = new URL('https://treams.com' + url) as any;

	return (
		<Popover visible={visible} backdrop center zoom={zoom}>
			{lastURL.current && (
				<Flex flexDirection="column" width={800} maxHeight="calc(90vh)" maxWidth="calc(90vw)">
					<Modal.Header
						title="Treams"
						onFullScreen={() => {
							setZoom(true);
							history.push(props.url);
						}}
						onClose={() => {
							const location = history.location;
							const params = new URLSearchParams(location.search);
							params.delete('modal');
							location.search = params.toString();
							history.push(location);
						}}
					/>
					<Box overflowY="scroll">
						<Router history={fake}>
							<ModalContext.Provider value={{ isModal: true }}>
								{props.children}
							</ModalContext.Provider>
						</Router>
					</Box>
				</Flex>
			)}
		</Popover>
	);
}
